export default __webpack_public_path__ + "static/media/hard-disk.de7386ea.jpg";